import { createContext } from 'react'

/** Implemented by the DOM-JSX ScrollView host. Coordinates are content-relative. */
export interface ScrollContainerHost {
  isAtTop: boolean
  offsetY: number
  scrollTo: (options: { y: number; animated: boolean }) => void
  measure: (target: unknown, done: (y: number, height: number) => void) => void
  viewportHeight: number
}
export const ScrollContainerContext = createContext<ScrollContainerHost | null>(null)
export interface ScrollOptions { block?: 'center' | 'nearest'; highlight?: boolean }
